
define('text!modules/campaign/templates/details.html',[],function () { return '<div class="w-CampaignDetails campaign-details-tabs"></div>\n';});

